import React, { useEffect, useState } from 'react';
import styles from './ball-game-new.module.css';
import BallsGameInstruction from '../balls-game-instruction/BallsGameInstruction';
import BallsGamePasscode from '../balls-game-passcode/BallsGamePasscode';
import { v4 as uuidv4 } from 'uuid';
import WinPriceModal from '../win-price-modal/WinPriceModal';
import { useSelector } from 'react-redux';
import { axios_updateVoucherStatus } from '../../apiConnections/voucherApi';
import { useParams } from 'react-router-dom';

const MAX_BALLS = 10;
const NEW_BALL_INTERVAL = 1000;
const GAME_DURATION = 10000 * 60 * 10; //10 = 10000 seconds
const BALL_SIZES = ['small', 'medium', 'large'];
const ROTATIONS = ['rotate1', 'rotate2', 'rotate3', 'rotate4', 'rotate5'];


export default function BallsGameNew() {

  const gameData = useSelector((state) => state?.game?.gameData)
  const { voucher_id } = useParams();


  const [objects, setObjects] = useState([]);
  const [score, setScore] = useState(1);
  const [clickedObjects, setClickedObjects] = useState([]);
  const [gameEnded, setGameEnded] = useState(false);
  const [isBackgroundAudioPlaying, setIsBackgroundAudioPlaying] = useState(false);
  const [isWinPriceModalOpen, setIsWinPriceModalOpen] = useState(false)

  const [currentStep, setCurrentStep] = useState("instruction") //instruction, passcode, game

  //sounds
  const bubblePopAudio = new Audio('../sound/egg-crack.wav');
  const ballGameWin = new Audio('../sound/ball-game-win.mp3');
  const ballGameFailSurprise = new Audio('../sound/ball-game-fail-surprise.mp3');

  //background sound functionalities
  useEffect(() => {
    const backgroundAudio = new Audio('../sound/egg-game-background-music.wav');

    if (isBackgroundAudioPlaying) {
      backgroundAudio.play()
      backgroundAudio.volume = 0.1;
      backgroundAudio.loop = true;
    } else {
      backgroundAudio.pause();
    }

    return () => {
      backgroundAudio.pause();
      backgroundAudio.currentTime = 0;
    }
  }, [isBackgroundAudioPlaying]);



  useEffect(() => {
    if (currentStep === "game") {
      const interval = setInterval(() => {
        if (gameEnded) {
          clearInterval(interval);
          return;
        }


        setObjects((prevObjects) => {
          const newObject = {
            id: uuidv4(),
            top: -50,
            left: Math.random() * (window.innerWidth - 50),
            speed: Math.floor(Math.random() * 2) + 5,
            size: BALL_SIZES[Math.floor(Math.random() * BALL_SIZES.length)],
            rotation: ROTATIONS[Math.floor(Math.random() * ROTATIONS.length)],
            clicked: false, // Add the 'clicked' property
          };
          if (prevObjects.length >= MAX_BALLS) {
            prevObjects.shift();
          }
          return [...prevObjects, newObject];
        });
      }, NEW_BALL_INTERVAL);

      const gameEndTimeout = setTimeout(() => {
        setGameEnded(true);
      }, GAME_DURATION);

      return () => {
        clearInterval(interval);
        clearTimeout(gameEndTimeout);
      };
    }
  }, [gameEnded, currentStep]);



  const handleClick = (id) => {


    //play pop sound
    bubblePopAudio.play();
    
    setClickedObjects((prevClickedObjects) => [...prevClickedObjects, id]);
    setObjects((prevObjects) =>
      prevObjects.map((obj) =>
        obj.id === id ? { ...obj, clicked: true } : obj
      )
    );
    setScore((prevScore) => prevScore + 1);
  
    if (score < gameData?.game?.win_count) {


      //delete the ball after 1.5 seconds,
      setTimeout(() => {
        setObjects((prevObjects) => prevObjects.filter((obj) => obj.id !== id));
      }, 1500);

      setTimeout(() => {
        ballGameFailSurprise.play()
      }, 1000);
    } else {
      ballGameWin.play()
      setGameEnded(true)
      //open modal
      setTimeout(() => {
        //remove full screen
        setIsWinPriceModalOpen(true)

      }, 500);

      //update step status
      const updateStatusReq = {
        voucher_id: voucher_id,
        status: 3 // won game
      }
      axios_updateVoucherStatus(updateStatusReq)

    }


    if (clickedObjects.includes(id)) {
      return; // exit function if the object has already been clicked
    }


    //reset red ball into white ball when not game won
    if (score > gameData?.game?.win_count) {
      setTimeout(() => {
        setObjects((prevObjects) =>
          prevObjects.map((obj) =>
            obj.id === id ? { ...obj, clicked: false } : obj
          )
        );
      }, 2000);
    }
  };



  return (
    <>




      <div className={styles.ball_game_wrapper}>

        <div className='position-absolute end-0 pt-2 pe-2'>
          <div className='sound-play-pause'>
            <button className='btn btn-dark d-flex' onClick={() => setIsBackgroundAudioPlaying(!isBackgroundAudioPlaying)}>
              {isBackgroundAudioPlaying ? "⏸️" : "▶️"}
              <span className='d-none d-sm-block'>{isBackgroundAudioPlaying ? "Pause 🎶" : "Play 🎶"}</span>
            </button>
          </div>
        </div>


        {currentStep === "game" ?
          <>
            {objects.map((obj) => (
              // !gameEnded && (
                <div
                  key={obj.id}
                  className={`${styles.object} ${styles[obj.size]} ${styles[!obj.clicked && obj.rotation]} ${obj.clicked ? styles.clicked : ''}`}
                  style={{
                    top: obj.top,
                    left: obj.left,
                    position: 'absolute'
                  }}
                  onMouseDown={() => !obj.clicked && handleClick(obj.id)}
                >
                  <img
                    src={obj.clicked ? "/images/broken_egg.png" : "/images/egg.png"}
                    alt={obj.clicked ? "broken egg" : "egg"}
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                  />
                {obj.clicked && (
                  <div className={`text-center`} style={{ position: 'absolute' }}>
                    <span className="text-dark fw-bold">
                      {score > gameData?.game?.win_count ? "Woohoo! You Won! 🎉🎈" : "Oops try again!"}
                    </span>
                  </div>
                )}
                </div>
              // )
            ))}
          </>
          :
          currentStep === "passcode" ?
            <BallsGamePasscode setCurrentStep={setCurrentStep} />
            :
            <div>
              <BallsGameInstruction setCurrentStep={setCurrentStep} setIsBackgroundAudioPlaying={setIsBackgroundAudioPlaying} />
            </div>
        }
      </div>

      <WinPriceModal isOpen={isWinPriceModalOpen} setIsOpen={setIsWinPriceModalOpen} prizeTitle={gameData?.game?.win_title} prizeMessage={gameData?.game?.win_msg} />

    </>
  );
}
